/**
 * switch.js
 */

import React from 'react';
import { 
  FormGroup,
  FormControlLabel,
  Switch as MuiSwitch,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';


export default function Switch(props) {
  const {
    formContext: formContextProp,
    name,
    rules,
    label,
    disabled,
    focusHandlers,
    component,
    onChange,
    ...rest
  } = props;

  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;
  const Component = component || MuiSwitch;

  // if switch is rendered with a null/empty value, set it to false
  React.useEffect(() => {
    const value = formContext.getValues(name);
    if (value === null || value === undefined) {
      formContext.setValue(name, false);
    }
  }, [formContext, name]);

  return (
    <Controller
      control={formContext.control}
      name={name}
      rules={rules}
      defaultValue={false}
      render={({ field: { ref, ...inputProps } }) => {
        return(
          <FormGroup>
            <FormControlLabel
              label={label}
              onFocus={e => {
                if (focusHandlers) {
                  focusHandlers.onFocus(e);
                }
              }}
              onBlur={e => {
                inputProps.onBlur(e);
                if (focusHandlers) {
                  focusHandlers.onBlur(e);
                }
              }}
              control={
                <Component
                  color="primary"
                  checked={Boolean(inputProps.value)}
                  onChange={e => { 
                    inputProps.onChange(e.target.checked);
                    if (onChange)
                      onChange(e);
                  }}
                  disabled={disabled}
                  {...rest}
                />
              }
            />
          </FormGroup>
        );
      }}
    />
  );
}